module.exports = __webpack_public_path__ + "img/tn-timeline-misc-4.93c965f5.jpg";